import _defineProperty from "/app/node_modules/.pnpm/next@13.4.17_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import { Component } from 'react';
import { connect } from 'react-redux';
import TranslationControl from 'components/TranslationControl';
import { ClickableElement } from 'constants/tracking/clickable-elements';
import * as statelessActions from 'state/user-feedback/actions';
import * as selectors from 'state/user-feedback/selectors';
import { jsx as _jsx } from "react/jsx-runtime";

const mapStateToProps = (state, _ref) => {
  let {
    feedbackId
  } = _ref;
  return {
    isTranslated: selectors.getFeedbackIsTranslated(state, feedbackId)
  };
};

const mapActionsToProps = {
  feedbackInitiateTranslation: statelessActions.feedbackInitiateTranslation
};
const connector = connect(mapStateToProps, mapActionsToProps);

class FeedbackTranslationButton extends Component {
  constructor() {
    super(...arguments);

    _defineProperty(this, "initiateTranslation", isTranslated => {
      const {
        feedbackId,
        feedbackInitiateTranslation
      } = this.props;
      feedbackInitiateTranslation({
        feedbackId,
        localize: !isTranslated
      });
    });
  }

  render() {
    const {
      feedbackId,
      isTranslated
    } = this.props;
    return /*#__PURE__*/_jsx(TranslationControl, {
      isTranslated: isTranslated,
      autotranslate: false,
      onClick: this.initiateTranslation,
      tracking: {
        target: ClickableElement.TranslateFeedback,
        targetDetails: feedbackId.toString()
      }
    });
  }

}

export default connector(FeedbackTranslationButton);